/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable max-len */

/*
 * @Description: 调用方式 window.JsBridge.Market
 * @Author: kadenwang@tencent.com
 * @Date: 2020-05-19 15:43:55
 * @LastEditors: yanxia@tencent.com
 * @LastEditTime: 2021-11-29 19:58:41
 */
import { getUrlParam } from '@tencent/halo-utils';
import { sleep, versionCompare } from './utils';
import { GetInstalledListHackMap } from './HackCode';
import { settings } from '../data';
// import { ls } from '@tencent/syzs-market-utils';
// import fetch from node-fetch;

export interface IQueryClientBaseInfo {
  supplyid: string;
  uiversion: string;
  appmarketversion: string;
  macaddress: string;
  language: string;
  isVNGVersion: boolean;
  sourceid: string;
}

export interface IQQUin {
  qqUin: string;
}

export interface IRet {
  ret: number;
}

export interface IRecommanded {
  recommanded: number;
}

export interface IClientVersionEx {
  market_version: string;
  rootfs_version: string;
  tbox_version: string;
  ui_version: string;
  vdi44_version: string;
  vdi71_version: string;
  main_version: string;
}
export interface IGetOnestoreCPUSerialNumber {
  cpuserialnumber: string;
}

export interface IQueryEngineAndApkStatus {
  pkgName: string;
  app_status: string;
  engine_status: string;
  engine_type: string;
  engine_progress: string;
}

export interface ICheckGlesEnvironment {
  pkgName: string;
  glesEnv: string;
}

export interface IApiError {
  code: number;
  errCode: string;
  api: string;
}

export interface IShowGameUpdateTipsOptions {
  pkgName: string;
  tipsUrl: string;
  width: number;
  height: number;
  frequency: number;
}

export interface ICpuInfo {
  cores: number;
  usage: number;
}

export interface IMemoryInfo {
  sizeInMB: number;
  usage: number;
}

export interface INetInfo {
  bandwidthInMbps: number;
  netInLoadInMbps: number;
  netOutLoadInMbps: number;
}

export interface IScreenInfo {
  fullScreen: boolean;
  screenSaverRunning: boolean;
}

export interface IhardDiskFreeSpace {
  isfull: boolean;
  /** 单位 Mb */
  sfFreeSpace: number;
}

export interface IEumlatorOrMarket {
  hasEumlator: boolean;
  hasMarket: boolean;
}

export interface ISysState {
  cpu: ICpuInfo;
  memory: IMemoryInfo;
  net: INetInfo;
  screen: IScreenInfo;
  isWow64: number; // 1是64位系统
  hardDiskFreeSpace: IhardDiskFreeSpace;
  eumlatorState: IEumlatorOrMarket;
}

export interface INotifyConditionOptions {
  cpuUsage: number;
  memUsage: number;
  netInLoadInMbps: number;
  hardDiskFreeSpace: number;
}

export enum IDownLoadControlFunc {
  beginInstall = 1,
  pauseInstall = 2,
  continueInstall = 3,
  cancelInstall = 4,
  updatePackage = 5,
  changeEngine = 6,
}

export interface IDownLoadControl {
  id: string;
  adtag?: string;
  updateJson?: any;
  preload: boolean;
  isLocalInstall: boolean;
  packageSize: string;
  localApkPath?: string;
  area: string;
  pcGameJson?: string;
  isPreDownloadItem?: boolean;
  itemType?: number;
  isGoogleAd?: boolean;
}

export interface ISetDownloadingXMLForPreDownload {
  pkgName: string;
  isPreDownloadItem?: boolean;
  overTime?: number;
}

export interface ISetMobileGamePcRegValDWORD {
  subPath?: string;
  key: string;
  value: 0 | 1;
}

export enum IResourceType {
  UNKNOW = 0,
  APK = 2,
  RESOURCE = 3,
}

export interface ISetAppWindowConfig {
  window: 'market';
  isOversea: boolean;
  width: number;
  height: number;
  minWidth: number;
  minHeight: number;
}

export interface IInstallGameByGoogleAd {
  pkgName: string;
  adurl: string;
  gameid: string;
  displayname: string;
  installType: number;
  area: string;
}

type RunAppInfo = {
  pkgName: string;
  engineType: string;
}

export interface IGetCurrentRunningApp {
  apps: RunAppInfo[];
}

export interface IInstallLocalAPKContinue {
  apkKey: string;
  // 继续安装还是取消安装 true 继续 false 取消
  instFlag: boolean;
}

export const g_callbackMap = {};
const clientReportList: Array<any> = []; // 客户端上报缓存队列

export let installedListCache;

let isClientReporting = false; // 客户端是否正在上报，避免上报太频繁，引起客户端失败
let reportedCount = 0; // 已经上报了的数量
let canShowGameUpdateTips = false;
let _guid = '';
let _clientInfo = {
  appmarketversion: '0',
  supplyid: '0',
  macaddress: '0',
};

function doWebReport(arr) {
  if (!arr.length) {
    return false;
  }

  arr.forEach((param) => {
    const items = [
      'guid',
      'imei',
      'channel_id',
      'version',
      'market_version',
      'user_type',
      'user_id',
      'mac_addr',
      'client_ip',
      'first_column',
      'second_column',
      'classification',
      'reserve',
      'slot',
      'src_scene',
      'action',
      'click_type',
      'button_type',
      'appid',
      'pkgname',
      'appname',
      'search_keyword',
      'button_state',
      'area',
      'standby1',
      'standby2',
      'standby3',
    ];
    Object.keys(param).forEach((v) => {
      if (!items.includes(v)) {
        delete param[v];
      }
    });

    param.second_column = param.second_column || '0';
    param.guid = _guid;
    param.version = _clientInfo.appmarketversion || '0';
    param.channel_id = _clientInfo.supplyid || '0';
    param.mac_addr = _clientInfo.macaddress || '0';
  });

  const query = `data=${encodeURIComponent(JSON.stringify(arr))}`;
  const headers = {};
  const fetchParam = {
    method: 'POST',
    mode: 'cors',
    body: '',
    headers: {},
  };
  headers['Content-Type'] = 'application/x-www-form-urlencoded';
  fetchParam.body = query;
  fetchParam.headers = headers;
  fetch('https://report.syzs.qq.com/bin/in/report.php', fetchParam as any)
    .then((response) => {
      if (!response.ok) {
        console.warn('网络连接错误！');
      }
    })
    .catch((e) => {
      console.warn(e);
    });
}

const Market = {
  ver: 3.0,
  apis: [] as Array<string>,
  gameState: {
    NotInstall: 0,
    Downloading: 1,
    DownloadPause: 2,
    Downloaded: 3,
    Installing: 4,
    InstallPause: 5,
    Installed: 6,
    Running: 7,
    WaitForDownload: 10,
    UpdateConfig: 14, // 正在更新配置
    CanUpgrade: 99, // web端自定义状态值，用于更新
  },
  installState: {
    BeginDownload: 0,
    EndDownload: 1,
    BeginInstall: 2,
    EndInstall: 3,
    BeginUninstall: 4,
    EndUninstall: 5,
    PauseInstall: 6,
    ContinueDownload: 7, // 继续下载
    WaitForDownload: 10, // 等待下载
    UpdateConfig: 14, // 正在更新配置
    CancelUpdate: 15, // 取消更新
  },
  ext: window.cef_external || window.external,
  __callTopApi: (api: string, params) => {
    if (!window.top || !window.top.postMessage) {
      // eslint-disable-next-line prefer-promise-reject-errors
      return Promise.reject({ code: 4000, errCode: 'ERRORWINDOW' });
    }

    return new Promise((resolve, reject) => {
      const extendCallId = `${Date.now()}_${Math.floor(Math.random() * 10000000)}`;
      window.top.postMessage(
        {
          type: 'marketApi',
          id: extendCallId,
          api,
          params,
        },
        '*',
      );

      g_callbackMap[extendCallId] = (nativeResult) => {
        if (nativeResult.succeed) {
          resolve(nativeResult.result);
        } else {
          reject(nativeResult.error);
        }
      };
    });
  },

  __asyncCallApi: (api: string, params?: any) => {
    if (window !== window.top) {
      return Market.__callTopApi('__asyncCallApi', [api, params]);
    }

    // 异步调用统一api
    return Market.getNativeApis(api !== 'getNativeApis').then(() => {
      if (!Market.ext) {
        Market.ext = window.cef_external || window.external;
      }

      const o = Market.ext;
      if (!o) {
        // eslint-disable-next-line prefer-promise-reject-errors
        return Promise.reject({ code: 3000, errCode: 'NOEXT' }); // 不存在external
      }

      if (!Market.checkHasApi(api)) {
        // eslint-disable-next-line prefer-promise-reject-errors
        return Promise.reject({ code: 3000, errCode: 'NOSUCHAPI', api }); // 不存在该api
      }

      return new Promise((resolve, reject) => {
        if (!o.nativeCall) {
          if (api === 'getNativeApis') {
            resolve([]);
            return;
          }

          const r = o[api].apply(o, ...params);
          console.log('browser', api, r);
          resolve(r);
          return;
        }

        // tbs内核 异步逻辑
        o.nativeCallEx(
          'NativeCallJsonString',
          [api, JSON.stringify(params || {})],
          (nativeResult) => {
            console.log(api, nativeResult);
            if (nativeResult.succeed) {
              resolve(JSON.parse(nativeResult.result));
            } else {
              reject(nativeResult.error);
            }
          },
        );
      });
    });
  },
  checkHasApi: (api: string) => {
    if (!Market.ext) {
      Market.ext = window.cef_external || window.external;
    }

    const o = Market.ext;
    if (!o) {
      return false;
    }

    if (api === 'getNativeApis') {
      return true;
    }

    if (!o.nativeCall) {
      if (o[api]) {
        Market.apis.push(api);
        return true;
      }

      return false;
    }

    return Market.apis.indexOf(api) !== -1;
  },
  getNativeApis: (need) => {
    if (!need || Market.apis.length) {
      return Promise.resolve(Market.apis);
    }

    return Market.__asyncCallApi('getNativeApis', {}).then(
      (apis) => {
        if (apis) Market.apis = apis;
        return Market.apis;
      },
      () => Market.apis,
    );
  },

  /**
   * do install control for apk
   * @param {number} func //1: install, 2: pause, 3: continue, 4:cancel, 5: update
   * @param {string} id
   * @param {string} adtag
   */
  InstallControl_New: (
    func: number,
    id: string,
    adtag?: string,
    updateJson?: any,
    preload = false,
    packageSize?: string,
    /** add area param for autoDownload: @kadenwang */
    area = '',
    /** add area param for pcGame download: @kadenwang */
    pcGameJson = '',
    isLocalInstall?: boolean,
    isPreDownloadItem?: boolean,
  ) => {
    const _adtag = adtag || getUrlParam('adtag') || 'TipUnknown';
    return Market.__asyncCallApi('Market.InstallControl_New', {
      func,
      id,
      adtag: _adtag,
      updateJson,
      preload,
      packageSize,
      isLocalInstall,
      area,
      pcGameJson,
      isPreDownloadItem,
    }).then((ret) => {
      // 客户端接口有改动，不再判断返回值
      if ([1, 3, 5].includes(func) && !preload) {
        // 安装， 更新
        // ls.setLaunchGames({ pkgname: id }, false);
        // eventbus.$emit(EVENTS.reloadLaunchGames);
      }

      return ret && ret.ret;
    });
  },

  DownLoadControl: (func: IDownLoadControlFunc, data: IDownLoadControl) => {
    const { adtag, id, updateJson, preload = false, isLocalInstall = false, packageSize, localApkPath, area = '', pcGameJson = '', isPreDownloadItem = false, itemType = IResourceType.APK } = data;
    const _adtag = adtag || getUrlParam('adtag') || 'TipUnknown';

    return Market.__asyncCallApi('Market.InstallControl_New', {
      func,
      id,
      adtag: _adtag,
      updateJson,
      preload,
      isLocalInstall,
      packageSize,
      localApkPath,
      area,
      pcGameJson,
      isPreDownloadItem,
      itemType,
    }).then((ret) => {
      // 客户端接口有改动，不再判断返回值
      if ([1, 3, 5].includes(func) && !preload) {
        // 安装， 更新
        // ls.setLaunchGames({ pkgname: id }, false);
        // eventbus.$emit(EVENTS.reloadLaunchGames);
      }

      return ret && ret.ret;
    });
  },

  /**
   * delete or launch apk
   * @param {number} func //10: delete, 11: launch
   * @param {string} id
   * @param {string} adtag
   */
  OperateApp: (func, id, adtag, itemType?, isGoogleAd?) => {
    const _adtag = adtag || getUrlParam('adtag') || 'TipUnknown';
    return Market.__asyncCallApi('Market.OperateApp', {
      func,
      id,
      adtag: _adtag,
      itemType: itemType || IResourceType.APK,
      isGoogleAd: isGoogleAd || false,
    }).then(
      (ret) => {
        if (ret && ret.ret === 0 && [10, 11].includes(func)) {
          // 删除， 启动
          // ls.setLaunchGames({ pkgname: id }, func === 10);
          // eventbus.$emit(EVENTS.reloadLaunchGames);
        }

        return ret && ret.ret;
      },
      () => -1,
    );
  },
  beginInstall: (id, adtag?, preload = false, updateJson?, packageSize?, area?) => Market.InstallControl_New(1, id, adtag, updateJson, preload, packageSize, area),
  pauseInstall: (id, adtag?, preload = false, updateJson?, packageSize?, area?) => Market.InstallControl_New(2, id, adtag, updateJson, preload, packageSize, area),
  continueInstall: (id, adtag?, preload = false, updateJson?, packageSize?, area?) => Market.InstallControl_New(3, id, adtag, updateJson, preload, packageSize, area),
  cancelInstall: (id, adtag?, preload = false, updateJson?, packageSize?, area?) => Market.InstallControl_New(4, id, adtag, updateJson, preload, packageSize, area),
  updatePackage: (id, adtag?, preload = false, updateJson?, packageSize?, area?) => Market.InstallControl_New(5, id, adtag, updateJson, preload, packageSize, area),

  beginInstallNew: (data: IDownLoadControl) => Market.DownLoadControl(IDownLoadControlFunc.beginInstall, data),
  pauseInstallNew: (data: IDownLoadControl) => Market.DownLoadControl(IDownLoadControlFunc.pauseInstall, data),
  continueInstallNew: (data: IDownLoadControl) => Market.DownLoadControl(IDownLoadControlFunc.continueInstall, data),
  cancelInstallNew: (data: IDownLoadControl) => Market.DownLoadControl(IDownLoadControlFunc.cancelInstall, data),
  updatePackageNew: (data: IDownLoadControl) => Market.DownLoadControl(IDownLoadControlFunc.updatePackage, data),
  changeEngineNew: (data: IDownLoadControl) => Market.DownLoadControl(IDownLoadControlFunc.changeEngine, data),

  deletePackage: (id, adtag, itemType?, isGoogleAd?) => Market.OperateApp(10, id, adtag, itemType, isGoogleAd),
  launchPackage: (id, adtag, itemType?, isGoogleAd?) => Market.OperateApp(11, id, adtag, itemType, isGoogleAd),
  cancelUpdatePackage: (id, adtag, itemType?) => Market.OperateApp(6, id, adtag, itemType),
  getVersion: (id) => Market.__asyncCallApi('Market.OperateApp', { func: 12, id }).catch(() => ''),
  getState: (id) => Market.__asyncCallApi('Market.OperateApp', { func: 13, id }).catch(() => -1),
  IsComponentInstalled: (id: number) => Market.__asyncCallApi('Market.IsComponentInstalled', { comId: id }).then((result) => {
    if (result && result.IsSuc === 1) {
      return result.ret !== 0;
    }

    return false;
  }, () => false),
  GetInstalledList: (flag) => {
    // 获取内容消耗内存,缓存数据起来
    if (!flag && installedListCache) {
      return Promise.resolve(installedListCache);
    }

    return Market.__asyncCallApi('Market.GetInstalledList')
      .then((games) => {
        const newGames = games.map((item) => {
          if (GetInstalledListHackMap[item.game_id]) {
            item.game_id = GetInstalledListHackMap[item.game_id];
          }

          return item;
        });

        installedListCache = newGames;
        return newGames;
      })
      .catch((err) => {
        let games;
        if (err.code === 3000) {
          games = [];
        }

        return games;
      });
  },

  // NOSUCHAPI
  DebugLog: (info: string) => Market.__asyncCallApi('Market.DebugLog', { info: `[AppMarket] ${info}` }),
  ShowMainWindow: (): Promise<IRet> => Market.__asyncCallApi('Market.ShowMainWindow', { show: true }),
  OpenUrlWithBrowser: (url: string): Promise<{}> => Market.__asyncCallApi('Market.OpenUrlWithBrowser', { url }),

  /** 下载中限速 */
  SetDownloadSpeedLimitOnDownloading: (limitSpeedInKBps: number): void => Market.__asyncCallApi('Market.SetDownloadSpeedLimitOnDownloading', { limitSpeedInKBps }),

  /** 改下载的xml */
  SetDownloadingXMLForPreDownload: (params: ISetDownloadingXMLForPreDownload): void => Market.__asyncCallApi('Market.SetDownloadingXMLForPreDownload', params),

  /** 修改注册表 */
  SetMobileGamePcRegValDWORD: (params: ISetMobileGamePcRegValDWORD): void => Market.__asyncCallApi('Market.SetMobileGamePcRegValDWORD', params),

  // 设置快速登录数据到客户端 已清空
  // NOSUCHAPI
  SetOpenIds: (info) => Market.__asyncCallApi('Market.SetOpenIds', { info }).then((ret) => ret.ret),

  /**
   *
   * @param {string} url
   * @param {string} injectUrl
   * @param {number} injectType
   * @param {number} width
   * @param {number} height
   * @param {string} adtag
   * @param {string} reportStr
   */
  OpenPopupFromTips: (
    url: string,
    injectUrl: string,
    injectType: number,
    width: number,
    height: number,
    adtag: string,
    reportStr: string,
  ): Promise<{}> => {
    const zoom = parseInt(localStorage.getItem('zoom') || '1', 10);
    // 该方法会有36的标题栏
    return Market.__asyncCallApi('Market.OpenPopupFromTips', {
      url,
      injectUrl,
      injectType,
      width: Math.ceil(width * zoom),
      height: 36 + Math.ceil((height - 36) * zoom),
      adtag,
      reportStr,
    });
  },

  OpenPopupWindow: (
    url: string,
    injectUrl: string,
    injectType: number,
    width: number,
    height: number,
    adtag: string,
    reportStr: string,
  ): Promise<{}> => {
    const zoom = parseInt(localStorage.getItem('zoom') || '1', 10);
    // 该方法会有36的标题栏
    return Market.__asyncCallApi('Market.OpenPopupWindow', {
      url,
      injectUrl,
      injectType,
      width: Math.ceil(width * zoom),
      height: 36 + Math.ceil((height - 36) * zoom),
      adtag,
      reportStr,
    });
  },

  UpdateClient: (param: string): Promise<IRet> => Market.__asyncCallApi('Market.UpdateClient', { param }),
  GetGuid: async (): Promise<string> => {
    // const guid = localStorage.getItem('guid');
    // if (guid) {
    //   return guid;
    // }

    try {
      const ret = await Market.__asyncCallApi('Market.GetGuid');
      if (ret && typeof ret === 'object') {
        // if (ret.guid) {
        //   localStorage.setItem('guid', ret.guid);
        // }

        return ret.guid || '0';
      }

      return ret || '0';
    } catch (error) {
      return '0';
    }
  },
  GetGaid: async (): Promise<string> => {
    try {
      const ret = await Market.__asyncCallApi('Market.GetGaid');
      if (ret && typeof ret === 'object') {
        return ret.gaid || '0';
      }

      return ret || '0';
    } catch (error) {
      return '0';
    }
  },
  GetExternParam: async (): Promise<{ extern_param?: { version_type?: string } }> => {
    try {
      const res = await Market.__asyncCallApi('Market.GetExternParam');
      return res;
    } catch (error) {
      return {};
    }
  },
  GetQQUin: (): Promise<IQQUin> => Market.__asyncCallApi('Market.GetQQUin'),
  SetClickInfo: (click: number): Promise<IRet | null> => Market.__asyncCallApi('Market.SetClickInfo', { click }).catch(() => null),

  OpenQQLoginUI: (needLogout: boolean, source?: number): Promise<number> => Market.__asyncCallApi('Market.OpenQQLoginUI', {
    needLogout,
    source: source || 0,
  }).then(
    () => 0,
    (e) => -1,
  ),
  OpenWeChatLoginUI: (needLogout: boolean, source?: number): Promise<number> => Market.__asyncCallApi('Market.OpenWeChatLoginUI', {
    needLogout,
    source: source || 0,
  }).then(
    () => 0,
    (e) => -1,
  ),
  InstallThirdParty: (params) => {
    const adtag = getUrlParam('adtag') || 'TipUnknown';
    return Market.__asyncCallApi('Market.InstallThirdParty', {
      pkgName: params.pkgName,
      displayName: params.displayName,
      url: params.url,
      iconUrl: params.iconUrl,
      apkMd5: params.apkMd5,
      versionName: params.versionName,
      appId: params.appId.toString(),
      adtag,
    });
  },

  // 获取客户端more game设置
  // TODO: recommanded
  QueryRecommendSwitch: () => Market.__asyncCallApi('Market.QueryRecommendSwitch')
    .then((ret) => ret.recommanded)
    .catch((e) => 0),

  /**
   * call Market when login from oversea account(google, twitter, etc)
   */
  OverseaLogin: (
    code: number,
    platform: string,
    nickname: string,
    headimgurl: string,
    openid: string,
    accesstoken: string,
  ): Promise<{}> => Market.__asyncCallApi('Market.OverseaLogin', {
    code,
    platform,
    nickname,
    headimgurl,
    openid,
    accesstoken,
  }),

  /**
   * call Market when logout from oversea account
   */
  OverseaLogout: (platform: string): Promise<{}> => Market.__asyncCallApi('Market.OverseaLogout', { platform }),

  QueryGameHistory: () => Promise.resolve([]),

  ReportEnviroment: (param: string): Promise<{}> => Market.__asyncCallApi('Market.ReportEnviroment', { param }),
  // TODO: 调用秒退
  CommitUserLog: (aiseeId: string, userId: string) => Market.__asyncCallApi('Market.CommitUserLog', { aiseeId, userId }),

  GetClientVersionEx: (): Promise<IClientVersionEx> => Market.__asyncCallApi('Market.GetClientVersionEx').then((ret) => ret),

  // onestore jsb 获取 cpu serial number
  GetOnestoreCPUSerialNumber: (): Promise<IGetOnestoreCPUSerialNumber> => Market.__asyncCallApi('Market.QueryClientCPUSerialNumber', {}).then((ret) => ret),

  // onestore 透传 onestore 登录 token 以及 age 给到终端
  OneStoreLogin: (onestoreAge: string, onestoreToken: string): Promise<{}> => Market.__asyncCallApi('Market.OneStoreLogin', { onestoreAge, onestoreToken }),

  // onestore 通知 onestore 登出给到终端
  OneStoreLogout: (): Promise<{}> => Market.__asyncCallApi('Market.OneStoreLogout', {}),

  // 本地安装继续下载逻辑
  InstallLocalAPKContinue: (info: IInstallLocalAPKContinue): Promise<{}> => Market.__asyncCallApi('Market.InstallLocalAPKContinue', info),

  // 检查是否有某个 API 简单版本
  checkHasApiV2: async (apiName) => {
    const result = await Market.__asyncCallApi('getNativeApis');

    if (Array.isArray(result) && result.includes(apiName)) {
      return true;
    }

    return false;
  },

  /**
   * web查询客户端基础信息 supply id version mac
   */

  QueryClientBaseInfo: async (): Promise<IQueryClientBaseInfo> => {
    const info = sessionStorage.getItem('Market.QueryClientBaseInfo');
    if (info) {
      return JSON.parse(info);
    }

    const res = await Market.__asyncCallApi('Market.QueryClientBaseInfo', {});
    sessionStorage.setItem('Market.QueryClientBaseInfo', JSON.stringify(res));
    return res;
  },

  /**
   * 获取游戏的引擎安装状态和进度
   */
  QueryEngineAndApkStatus: (pkgName: string): Promise<IQueryEngineAndApkStatus> => Market.__asyncCallApi('Market.QueryEngineAndApkStatus', { pkgName }),

  CheckGlesEnvironment: (pkgName: string): Promise<ICheckGlesEnvironment> => Market.__asyncCallApi('Market.CheckGlesEnvironment', { pkgName }),

  // web查询是否支持迁移
  IsMigrateApk: (pkgName: string) => Market.__asyncCallApi('Market.IsMigrateApk', { pkgName }),

  // web点击开始迁移
  MigrateApk: (pkgName: string) => Market.__asyncCallApi('Market.WebClickMigrateApk', { pkgName }),

  // 安装多区服应用, 返回 0 为成功，undefined/-1 为失败
  InstallGameWithArea: (
    func,
    pkgName,
    displayName,
    url,
    apkMd5,
    adtag,
    gameId,
    area,
    pkgType,
  ) => Market.__asyncCallApi('Market.InstallGameWithArea', {
    func,
    pkgName,
    displayName,
    url,
    apkMd5,
    adtag,
    gameId,
    area,
    pkgType,
  }).then((r) => r.ret),

  // 获取游戏上次启动区服
  QueryGameLastArea: (gameId: string): Promise<string> => Market.__asyncCallApi('Market.QueryGameLastArea', { gameId }).then((ret) => ret.area),

  // 注意：此处将返回改为函数调用结果
  OpenSettings: (): Promise<{}> => Market.__asyncCallApi('Market.OpenSettings', {}),

  // 注意：此处将返回改为函数调用结果 打开诊断窗口（已不用）
  OpenDiagnostic: (): Promise<{}> => Market.__asyncCallApi('Market.OpenDiagnostic', {}),

  // 注意：此处将返回改为函数调用结果 获取诊断窗口的信息
  GetDiagnosticInfo: (): Promise<{}> => Market.__asyncCallApi('Market.GetDiagnosticInfo', {}),

  // 注意：此处将返回改为函数调用结果 生成诊断报告并打开文件夹
  GenDiagnosticReport: (): Promise<{}> => Market.__asyncCallApi('Market.GenDiagnosticReport', {}),

  // 注意：此处将返回改为函数调用结果 立即更新
  UpdateRightNow: (updateInfo): Promise<{}> => Market.__asyncCallApi('Market.UpdateRightNow', updateInfo),

  // 注意：此处将返回改为函数调用结果 确认更新重启市场
  BeSureToUpdate: (): Promise<{}> => Market.__asyncCallApi('Market.BeSureToUpdate', {}),

  // 注意：此处将返回改为函数调用结果 修改本地市场版本号
  FixLocalInfoInUpdate: (mainver): Promise<{}> => Market.__asyncCallApi('Market.FixLocalInfoInUpdate', mainver),

  // 注意：此处将返回改为函数调用结果 取消更新
  CancelUpdate: (): Promise<{}> => Market.__asyncCallApi('Market.CancelUpdate', {}),

  // 注意：此处将返回改为函数调用结果
  CheckUpdate: (): Promise<{}> => Market.__asyncCallApi('Market.CheckUpdate', {}),

  Logout: (source?: number): Promise<{}> => Market.__asyncCallApi('Market.LogoutQQOrWeChat', { source: source || 0 }),

  OpenVoiceBuddy: (): Promise<{}> => Market.__asyncCallApi('Market.OpenVoiceBuddy', {}),

  InstallLocalAPK: (): Promise<IRet> => Market.__asyncCallApi('Market.InstallLocalAPK', {}),
  SetCurUserDwordRegister: (key: string, value: number): Promise<{}> => Market.__asyncCallApi('Market.SetCurUserDwordRegister', { key, value }),
  // 队列客户端上报
  ReportWebData: async (dataOptions?: any, type?: any) => {
    if (
      dataOptions
      && dataOptions.type_log
      && dataOptions.type_log !== 'webapp_v3'
    ) {
      return false;
    }

    if (dataOptions) {
      if (type === 1) {
        clientReportList.unshift(dataOptions); // 改为插入至队列前面
      } else {
        clientReportList.push(dataOptions);
      }
    }

    if (isClientReporting) {
      return false;
    }

    const d = clientReportList.shift();
    if (!d) {
      return false;
    }

    isClientReporting = true;
    reportedCount += 1;
    if (reportedCount > 5) {
      // 10 -> 5 减少次数
      await sleep(1000);
      reportedCount = 0;
    }

    try {
      const res = await Promise.all([
        Market.__ReportWebData(d),
        Market.BeaconReport(d),
      ]);
      isClientReporting = false;
      Market.ReportWebData();
    } catch (e) {
      isClientReporting = false;
      // d.retryTime = +(d.retryTime || 0)+1;
      // if(d.retryTime <3){ //最多重试3次，避免引起后台雪崩
      //     Market.ReportWebData(d);
      // }else{
      Market.ReportWebData();
      //     d.first_column = 'webreport2.test.com/500/'+d.first_column
      //     doWebReport([d]);
      // }
    }
  },
  /**
   * 移商上报规范
   *
   */
  BeaconReport: (dataOptions) => {
    if (!dataOptions.event_type) {
      console.error('没有event_type', dataOptions);
      // return;
    }

    if (!dataOptions.event_code) {
      console.error('没有event_code', dataOptions);
      // return;
    }

    const SubField1MatchArray = [
      'event_time',
      'event_type',
      'event_code',
      'event_value',
      'event_target',
    ];
    const SubField2MatchArray = [
      'session_start_time',
      'page_id',
      'uri',
      'pv_id',
      'position',
      'logintype',
      'login_openid',
      'session_id',
      'last_session_id',
      'referrer',
      'last_pv_id',
    ];
    const data = {
      other_params: {},
    };
    Object.keys(dataOptions).forEach((i) => {
      if (SubField1MatchArray.indexOf(i) > -1) {
        data[i] = dataOptions[i];
      }

      if (SubField2MatchArray.indexOf(i) > -1) {
        data.other_params[i] = dataOptions[i].toString();
      }
    });

    console.log('----BeaconReport');

    return Market.__asyncCallApi('BeaconReport.Report', data);
    //   .then(res=>{
    //       if(res.succeed){
    //       // Market.ReportWebData();
    //       }else{
    //           dataOptions.beaconRetryTime = +(dataOptions.beaconRetryTime || 0)+1;
    //           if(dataOptions.beaconRetryTime <3){ //最多重试3次，避免引起后台雪崩
    //               return Market.BeaconReport(dataOptions);
    //           }else{
    //               // Market.ReportWebData();
    //               dataOptions.first_column = 'webreport2.test.com/501/'+dataOptions.first_column
    //               return doWebReport([dataOptions]);
    //           }
    //       }
    //   }).catch(e=> {
    //       isClientReporting = false;
    //       dataOptions.beaconRetryTime = +(dataOptions.beaconRetryTime || 0)+1;
    //       if(dataOptions.beaconRetryTime <3){ //最多重试3次，避免引起后台雪崩
    //           return Market.BeaconReport(dataOptions);
    //       }else{
    //       // Market.ReportWebData();
    //           dataOptions.first_column = 'webreport2.test.com/500/'+dataOptions.first_column
    //           return doWebReport([dataOptions]);
    //       }
    //   })
  },
  /**
   * 接口描述调用客户端数据上报接口
   * dataOptions:数据上报参数
   * 返回 {result:1} 表示上报成功
   */
  // TODO:
  __ReportWebData: (dataOptions) => {
    let type_log = 'webapp_v3';
    dataOptions.action = +dataOptions.action || 0;
    dataOptions.slot = (dataOptions.slot || '0').toString();
    const subField1 = {};
    const subField2 = {};
    const subField3 = {};
    const subField4 = {};
    const SubField1MatchArray = [
      'user_type',
      'user_id',
      'first_column',
      'second_column',
      'classification',
      'slot',
    ];
    const SubField2MatchArray = [
      'src_scene',
      'action',
      'click_type',
      'button_type',
      'search_keyword',
      'button_state',
    ];
    const SubField3MatchArray = [
      'pkgname',
      'appname',
      'area',
      'online_times',
      'change_times',
    ];
    const SubField4MatchArray = [
      'standby1',
      'standby2',
      'standby3',
      'standby4',
      'standby5',
      'standby6',
    ];
    Object.keys(dataOptions).forEach((i) => {
      if (i === 'type_log') {
        type_log = dataOptions[i];
      }

      if (SubField1MatchArray.indexOf(i) > -1) {
        subField1[i] = dataOptions[i];
      }

      if (SubField2MatchArray.indexOf(i) > -1) {
        subField2[i] = dataOptions[i];
      }

      if (SubField3MatchArray.indexOf(i) > -1) {
        subField3[i] = dataOptions[i];
      }

      if (SubField4MatchArray.indexOf(i) > -1) {
        subField4[i] = dataOptions[i].toString();
      }
    });

    console.log('----marketreport');
    return Market.__asyncCallApi('Market.ReportWebData', {
      type_log,
      subField1,
      subField2,
      subField3,
      subField4,
    })
      .then((res) => {
        if (res.result === 1) {
          // Market.ReportWebData();
        } else {
          dataOptions.retryTime = +(dataOptions.retryTime || 0) + 1;
          if (dataOptions.retryTime < 3) {
            // 最多重试3次，避免引起后台雪崩
            return Market.__ReportWebData(dataOptions);
          }

          // Market.ReportWebData();
          dataOptions.first_column = `webreport2.test.com/501/${dataOptions.first_column}`;
          return doWebReport([dataOptions]);
        }
      })
      .catch((e) => {
        isClientReporting = false;
        dataOptions.retryTime = +(dataOptions.retryTime || 0) + 1;
        if (dataOptions.retryTime < 3) {
          // 最多重试3次，避免引起后台雪崩
          return Market.__ReportWebData(dataOptions);
        }

        // Market.ReportWebData();
        dataOptions.first_column = `webreport2.test.com/500/${dataOptions.first_column}`;
        return doWebReport([dataOptions]);
      });
  },
  /*
    SysMon.StartPerfMon() 开始系统性能监控 每秒刷新
  */
  StartPerfMon: (): Promise<{}> => Market.__asyncCallApi('SysMon.StartPerfMon'),
  /*
    SysMon.StopPerfMon()   停止系统性能监控
  */
  StopPerfMon: (): Promise<{}> => Market.__asyncCallApi('SysMon.StopPerfMon'),
  /*
    SysMon.StopPerfMon()   停止系统性能监控
  */
  GetCurrentRunningApp: (): Promise<IGetCurrentRunningApp> => Market.__asyncCallApi('SysMon.GetCurrentRunningApp'),
  /*
    设置监控通知阈值
    SysMon.SetNotifyCondition( {cpuUsage: number, memUsage : number, netInLoadInMbps : number }  )
  */
  SetNotifyCondition: ({ cpuUsage, memUsage, netInLoadInMbps, hardDiskFreeSpace }: INotifyConditionOptions): Promise<{}> => Market.__asyncCallApi('SysMon.SetNotifyCondition', {
    cpuUsage,
    memUsage,
    netInLoadInMbps,
    hardDiskFreeSpace,
  }),
  /*
    获取当前系统信息（cpu, mem, net, screen）
    SysMon.GetCurrentSysState()
  */
  GetCurrentSysState: (): Promise<ISysState> => Market.__asyncCallApi('SysMon.GetCurrentSysState'),
  ShowGameUpdateTips: (options: IShowGameUpdateTipsOptions): Promise<{} | IApiError> => {
    // 限定版本号
    if (canShowGameUpdateTips) {
      return Market.__asyncCallApi('Market.ShowGameUpdateTips', options);
    }

    // eslint-disable-next-line prefer-promise-reject-errors
    return Promise.reject({
      code: 3000,
      errCode: 'NOSUCHAPI',
      api: 'Market.ShowGameUpdateTips',
    });
  },
  /**
     * 登录成功回调客户端
     * params.result 登录结果，成功1，失败0
     * params.openid
     * params.platform 登录平台：qq传qq，微信传weixin
     * params.accesstoken
     */
  ChinaLoginCallback(params) {
    return this.__asyncCallApi('Market.ChinaLoginCallback', params);
  },
  // 登出回调客户端
  ChinaLogoutCallback() {
    return this.__asyncCallApi('Market.ChinaLogoutCallback');
  },
  // 通知客户端已切换qq互联
  QqOpenidValid() {
    return this.__asyncCallApi('Market.QqOpenidValid');
  },
  // 获取设置信息
  InitSettingTabs: (): Promise<{
    Basic: settings.InitSettingTabsBasic;
    Engine?: settings.InitSettingTabsEngine;
    Phone?: settings.InitSettingTabsPhone;
    Game?: settings.InitSettingTabsGame;
  }> => Market.__asyncCallApi('Market.InitSettingTabs'),
  SaveBasicTab(params: Partial<settings.InitSettingTabsBasic>) {
    return this.__asyncCallApi('Market.SaveBasicTab', params);
  },
  SaveEngineTab(params) {
    return this.__asyncCallApi('Market.SaveEngineTab', params);
  },
  SavePhoneTab(params: Partial<settings.InitSettingTabsPhone>) {
    return this.__asyncCallApi('Market.SavePhoneTab', params);
  },
  SaveGameTab(params: Partial<settings.InitSettingTabsGame>) {
    return this.__asyncCallApi('Market.SaveGameTab', params);
  },
  /**
   * 检查快捷键是否被占用
   * @param params
   */
  CheckHotKeyConflict(params: { bossKey: [settings.SettingKeyState, settings.SettingKeyValue] }) {
    return this.__asyncCallApi('Market.CheckHotKeyConflict', params);
  },
  /**
   * 选择路径
   * @param params
   */
  BrowseDirPath(params: { path: string }) {
    return this.__asyncCallApi('Market.BrowseDirPath', params);
  },
  OpenDir(params: { path: string }) {
    return this.__asyncCallApi('Market.OpenDir', params);
  },
  /**
   * 读 appConfig
   * @returns null
   */
  GetAppConfig() {
    return this.__asyncCallApi('Market.GetAppConfig');
  },
  /**
   * 写入 appConfig
   * @returns null
   */
  SetAppWindowConfig(params: ISetAppWindowConfig) {
    return this.__asyncCallApi('Market.SetAppWindowConfig', params);
  },
  /**
   * 获取客户端打包版本
   * @returns 0 国内 ；1 海外
   */
  async International(): Promise<number> {
    const result = await this.__asyncCallApi('Market.International');
    return +result?.res || 0;
  },
  /**
   * 主动更新市场离线页
   * 更新成功后会回调webcall.CompleteLocalPageUpdate
   */
  async UpdateMarketLocalPage() {
    if (this.checkHasApi('Market.UpdateMarketLocalPage')) {
      return this.__asyncCallApi('Market.UpdateMarketLocalPage');
    }
  },
  /** 黎明觉醒、注册成功通知客户端 */
  LMJXSignupSuccess(params: { isOK: boolean }) {
    return this.__asyncCallApi('Market.LMJXSignupSuccess', params);
  },
  InstallGameByGoogleAd(params: IInstallGameByGoogleAd) {
    return this.__asyncCallApi('Market.InstallGameByGoogleAd', params);
  },
  Feature() {
    return this.__asyncCallApi('Market.Feature').catch(() => ({}));
  },
};

Market.QueryClientBaseInfo().then((info) => {
  canShowGameUpdateTips = versionCompare((info && info.appmarketversion) || '', '3.10.105.100') >= 0;
  _clientInfo = info;
});

Market.GetGuid().then((g) => {
  _guid = g;
});

export default Market;
